import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function Hero() {
  return <section className="relative flex items-center pt-32 pb-16 overflow-hidden" data-id="element-57">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-58">
        <img src="https://images.unsplash.com/photo-1601362840469-51e4d8d58785?auto=format&fit=crop&q=80&w=2000" alt="Luxury car detailing" className="w-full h-full object-cover object-center" data-id="element-59" />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-darker via-brand-darker/90 to-brand-darker/40" data-id="element-60"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-brand-darker via-transparent to-transparent" data-id="element-61"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-62">
        <div className="max-w-3xl" data-id="element-63">
          <FadeIn delay={0.1} data-id="element-64">
            <div className="inline-block mb-4 px-3 py-1 border border-brand-red/30 bg-brand-red/10 text-brand-red font-heading tracking-widest text-sm" data-id="element-65">
              Hurlingham, Buenos Aires
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-66">
            <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight text-balance" data-id="element-67">
              Detailing Automotor{' '}
              <span className="text-brand-red" data-id="element-68">Profesional</span>
            </h1>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-69">
            <h2 className="text-xl md:text-2xl text-white font-medium mb-6" data-id="element-70">
              Tu auto como nuevo. Calidad, dedicación y atención al detalle.
            </h2>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-71">
            <div className="space-y-4 text-brand-muted text-lg mb-10 max-w-2xl" data-id="element-72">
              <p data-id="element-73">
                En Morello Detailing nos especializamos en el lavado, limpieza y
                detallado automotor para quienes buscan mantener su vehículo
                impecable.
              </p>
              <p data-id="element-74">
                Trabajamos con productos de primera calidad y técnicas
                profesionales para cuidar cada superficie de tu vehículo,
                logrando resultados que se notan desde el primer servicio.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-75">
            <div className="relative rounded-sm overflow-hidden border border-white/10 shadow-2xl bg-black max-w-2xl" data-id="element-76">
              <video controls className="w-full h-auto aspect-video object-cover" poster="https://cdn.magicpatterns.com/uploads/kzjSnTacTYKxM2nx8o8K4h/Captura_de_pantalla_2026-06-19_122459.png" data-id="element-77">
                <source src="https://cdn.magicpatterns.com/uploads/xu3mvDBkvYUhGDpMXN93Rc/VN20260619_125456%20(1)%20(1).mp4" type="video/mp4" data-id="element-78" />
                Tu navegador no soporta la reproducción de videos.
              </video>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}